import moment from 'moment';

import isBeforeDay from './isBeforeDay';

export default function isInclusivelyAfterDay(a, b) {
    if (!moment.isMoment(a) || !moment.isMoment(b)) return false;
    return !isBeforeDay(a, b);
}
